// extracted by mini-css-extract-plugin
export default {"objective":"styles_objective__J-R1R"};